module.exports = __webpack_public_path__ + "img/ico-checklist-pin.48ed49dd.svg";